import { render, staticRenderFns } from "./PositionDetails.vue?vue&type=template&id=5600aa60&scoped=true&"
import script from "./PositionDetails.vue?vue&type=script&lang=js&"
export * from "./PositionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PositionDetails.vue?vue&type=style&index=0&id=5600aa60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600aa60",
  null
  
)

export default component.exports